import React from 'react';
import { motion } from 'framer-motion';
const values = [{
  emoji: '🍞',
  title: 'Recetas listas para vender',
  description: '12 recetas probadas, diseñadas para cualquier horno de casa.'
}, {
  emoji: '💰',
  title: 'Cómo asegurarte de ganar plata',
  description: 'Calculadora de costos incluida — sabés exactamente cuánto cobrar en cada venta.'
}, {
  emoji: '🏠',
  title: 'Cómo producir desde tu casa',
  description: 'Organizá tu cocina actual sin comprar equipos ni hacer un desastre.'
}, {
  emoji: '📋',
  title: 'Plan paso a paso de 15 días',
  description: 'Tu hoja de ruta diaria desde el día 1 hasta tu primera entrega.'
}];
export function ValueSection() {
  return <section className="py-24 px-4 sm:px-6 lg:px-8 relative border-t border-white/5 overflow-hidden" data-id="element-287">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat scale-105" style={{
      backgroundImage: "url('https://cdn.magicpatterns.com/uploads/4crew2FcLd5m4toxck4rbp/tasty-cropped-pie-parchment_(1).jpg')"
    }} data-id="element-288" />
      {/* Mobile: slightly darker overlay (45%), Desktop: lighter (40%) */}
      <div className="absolute inset-0 bg-charcoal-dark/[0.45] md:bg-charcoal-dark/[0.40] z-0" data-id="element-289" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-290">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-291">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" style={{
          textShadow: '0 2px 12px rgba(0,0,0,0.5), 0 1px 3px rgba(0,0,0,0.4)'
        }} data-id="element-292">
            Todo lo que necesitás{' '}
            <span className="text-gold italic font-normal" data-id="element-293">para empezar</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-294">
          {values.map((value, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-charcoal-dark/60 backdrop-blur-md border border-white/10 p-8 rounded-2xl hover:border-gold/30 hover:bg-charcoal-dark/70 transition-all duration-300 group" data-id="element-295">
              <div className="text-4xl mb-6 transform group-hover:scale-110 transition-transform duration-300 origin-left" data-id="element-296">
                {value.emoji}
              </div>
              <h3 className="text-xl font-serif font-semibold mb-4 text-cream group-hover:text-gold-light transition-colors" data-id="element-297">
                {value.title}
              </h3>
              <p className="text-cream-muted/80 text-base leading-relaxed" data-id="element-298">
                {value.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}